import { toast } from 'react-toastify';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import BeatLoader from 'react-spinners/BeatLoader';
import { MultiSelect } from 'react-multi-select-component';
import { Button, TextField, InputAdornment, Select, MenuItem, InputLabel, FormControl } from '@material-ui/core';
import Swal from 'sweetalert2'


import Prompt from '../../../Shared/Prompt/Prompt';
import PromptWrapper from '../../../Shared/Prompt/Wrapper';
import PromptActions from '../../../Shared/Prompt/Actions';

import { roles } from '../../../../Shared/utils';
import { create } from '../../../../Functions/admin';
import { useAppContext } from '../../../../Context/App/Provider';
import { multiSelectStrings } from '../../../../Functions/utils';
import { useReportingContext } from '../../../../Context/Reporting/Provider';

import { decodeHTMLEntities } from '../../../../Functions/utils';
import { toastTimerValue } from '../../../../Shared/utils'; 
import '../../../SweetAlert.css'


export default function CreateAccount({users, setUsers, setSelectedUser}) {
  const { t } = useTranslation();
  const [{user}] = useAppContext();
  const [{pickers}] = useReportingContext();
  // const locations = pickers.locations.all.map(loc => { loc.label = loc.label.replace('\u2001', ''); return loc; });
  const tmpLocations = JSON.parse(JSON.stringify(pickers.locations.all));
  const locations = tmpLocations.map(loc => { loc.label = loc.label.replace(/\u2001/g, ''); return loc; });

  const [loading, setLoading] = useState(false);
  const [newUser, setNewUser] = useState({
    roleId: roles.user,
    email: '',
    password: '',
    passCheck: '',
    contactEmail: '',
    groupId: user.groupId ?? '0',
    locations: []
  });


  const handleCreateUser = (e, user) => {
    e.preventDefault();
    setLoading(true);

    // Set group to NULL for SoftThinks Admins
    user.groupId = !Number(user.groupId) ? null : user.groupId;
    user.contactEmailActivated = user.contactEmail ? true : false;

    create({type: 'user', user}).then(res => {
      setLoading(false);
      if (!res || !res.success) {
        return toast(decodeHTMLEntities(t('admin.accounts.errors.' + res, { email: user.email })), { type: 'error' });

        // return Swal.fire({
        //   toast: true,
        //   icon: 'error',
        //   title:t('admin.accounts.errors.' + res, { email: user.email }),
        //   animation: true,
        //   position: 'top-right',
        //   showConfirmButton: false,
        //   timer: toastTimerValue,
        //   timerProgressBar: true,
        //   iconColor: 'white',
        //   customClass: {
        //     popup: 'colored-toast',
        //   },
        //   didOpen: (toast) => {
        //     toast.addEventListener('mouseenter', Swal.stopTimer)
        //     toast.addEventListener('mouseleave', Swal.resumeTimer)
        //     toast.addEventListener('click', Swal.close)
        //   }
        // });
      }

      const newRows = users.concat({...res.user, role: t('admin.accounts.types.' + res.user.roleId)});
      setUsers(newRows.sort((a, b) => a.email.localeCompare(b.email)));

      setSelectedUser(null);
      toast(decodeHTMLEntities(t('admin.accounts.create.success', { email: user.email })), { type: 'success' });

      // Swal.fire({
      //   toast: true,
      //   icon: 'success',
      //   title: t('admin.accounts.create.success', { email: user.email }),
      //   animation: true,
      //   position: 'top-right',
      //   showConfirmButton: false,
      //   timer: toastTimerValue,
      //   timerProgressBar: true,
      //   iconColor: 'white',
      //   customClass: {
      //     popup: 'colored-toast',
      //   },
      //   didOpen: (toast) => {
      //     toast.addEventListener('mouseenter', Swal.stopTimer)
      //     toast.addEventListener('mouseleave', Swal.resumeTimer)
      //     toast.addEventListener('click', Swal.close)
      //   }
      // });
    });
  };

  return (
    <Prompt animated>
      <form className="prompt__container animated" onSubmit={e => handleCreateUser(e, newUser)}>
        <PromptWrapper>
          <div className="prompt__title">
            <h1>{t('admin.accounts.create.title')}</h1>
            <div>
              <select
                value={newUser.roleId}
                className="singleSelect"
                title={t('admin.accounts.columns.role')}
                onChange={e => {
                  const roleId = Number(e.target.value);
                  const groupId = roleId <= roles.stAdmin ? '0' : newUser.groupId;
                  const locations = roleId !== roles.user ? [] : newUser.locations;
                  setNewUser({...newUser, roleId, groupId, locations});
                }}
              >
                <option value="2">{t('admin.accounts.types.' + roles.user)}</option>
                <option value="1">{t('admin.accounts.types.' + roles.admin)}</option>
                {user.roleId <= roles.stAdmin && <option value="0">{t('admin.accounts.types.' + roles.stAdmin)}</option>}
                {user.roleId <= roles.dashboardSuperAdmin && <option value="-1">{t('admin.accounts.types.' + roles.dashboardSuperAdmin)}</option>}
              </select>
            </div>
          </div>

          <div className="prompt__content">
            <div className="flexRow">
              {user.roleId <= roles.stAdmin && (
              <div>
                <p className="sidebar__label">{t('admin.accounts.columns.group')}</p>
                <select
                  value={newUser.groupId}
                  className="singleSelect"
                  disabled={newUser.roleId <= roles.stAdmin}
                  onChange={e => setNewUser({...newUser, groupId: Number(e.target.value) || null, locations: []})} // Replace "no group" by null
                >
                  <option value="0" hidden>{t('admin.accounts.create.no_group')}</option>
                  {pickers.groups.map(group => <option key={group.value} value={group.value}>{group.label}</option>)}
                </select>
              </div>
              )}

              {/* <div style={{ width: '100%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('admin.accounts.columns.group')}</InputLabel>
                  <Select
                    onChange={e => setNewUser({ ...newUser, groupId: Number(e.target.value) || null, locations: [] })} // Replace "no group" by null
                    value={newUser.groupId}
                    label={t('admin.accounts.columns.group')}
                  >                   
                    {pickers.groups.map(group => <MenuItem key={group.value} value={group.value}>{group.label}</MenuItem>)}
                  </Select>
                </FormControl>
              </div> */}


              <div className={'sidebar__select' + (newUser.roleId !== roles.user ? ' disabled' : '')}>
                <p className="sidebar__label">{t('sidebar.filters.locations')}</p>
                <MultiSelect
                  value={newUser.locations}
                  onChange={locations => setNewUser({...newUser, locations})}
                  options={locations.filter(loc => loc.group === newUser.groupId)}
                  disabled={!Number(newUser.groupId) || newUser.roleId !== roles.user}
                  ArrowRenderer={() => <span className="material-icons-round rmsc__arrow">expand_more</span>}
                  overrideStrings={{...multiSelectStrings(t), allItemsAreSelected: newUser.locations.map(loc => loc.label).join(', ')}}
                  valueRenderer={(items) => {
                    const values = items.map(loc => loc.label).join(', ');
                    return items.length > 0 ? <span title={values}>{values}</span> : multiSelectStrings(t).selectSomeItems;
                  }}
                />
              </div>

              {/* <div style={{ width: '100%' }}>
                <FormControl variant="outlined" style={{ width: '100%' }}>
                  <InputLabel>{t('sidebar.filters.locations')}</InputLabel>
                  <Select
                    multiple
                    onChange={e => setNewUser({ ...newUser, locations: e.target.value })}
                    value={newUser.locations}
                    label={t('sidebar.filters.locations')}
                  >
                    {locations.map(loc =>
                      (loc.group === newUser.groupId) ? <MenuItem key={loc.value} value={loc.value}>{loc.label}</MenuItem> : <div></div>
                    )}
                  </Select>
                </FormControl>
              </div> */}
            </div>



            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">account_circle</span>
                </InputAdornment>
              }}
              required
              name="no-username"
              autoComplete="off"
              variant="outlined"
              value={newUser.email}
              label={t('admin.accounts.columns.email')}
              onChange={e => setNewUser({...newUser, email: e.target.value})}
            />

            <TextField
              InputProps={{
                startAdornment: <InputAdornment position="start">
                  <span className="material-icons-outlined">email</span>
                </InputAdornment>
              }}
              name="no-email"
              autoComplete="off"
              variant="outlined"
              value={newUser.contactEmail}
              label={t('admin.accounts.columns.contact_email')}
              onChange={e => setNewUser({...newUser, contactEmail: e.target.value})}
            />

            <div className="flexRow">
              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">lock</span>
                  </InputAdornment>
                }}
                required
                type="password"
                variant="outlined"
                value={newUser.password}
                label={t('reset.field1')}
                onChange={e => setNewUser({...newUser, password: e.target.value})}
              />

              <TextField
                InputProps={{
                  startAdornment: <InputAdornment position="start">
                    <span className="material-icons-outlined">lock</span>
                  </InputAdornment>
                }}
                required
                type="password"
                variant="outlined"
                value={newUser.passCheck}
                label={t('reset.field2')}
                onChange={e => setNewUser({...newUser, passCheck: e.target.value})}
              />
            </div>
          </div>
        </PromptWrapper>

        <PromptActions>
          <Button className="btnSecondary" onClick={() => setSelectedUser(null)}>
            {t('global.cancel')}
          </Button>

          <Button className="btnPrimary" type="submit" disabled={loading}>
            {loading ? <BeatLoader color="white" css="transform:translateY(4px)"/> : t('global.create')}
          </Button>
        </PromptActions>
      </form>
    </Prompt>
  );
}
